import React, { lazy, Suspense } from 'react';
import SEO from './components/common/SEO';
import LoadingScreen from './components/common/LoadingScreen';
import { AudioProvider, useAudio } from './context/AudioContext';

import LandingScreen from './components/marketing/LandingScreen';

const Experience = lazy(() => import('./components/Experience'));

const SolunnContent: React.FC = () => {
  const {
    isAudioStarted,
    handleStartAudio
  } = useAudio();

  return (
    <div className={`relative w-full ${isAudioStarted ? 'h-[100dvh]' : 'min-h-screen'} bg-black`}>
      <SEO
        title={isAudioStarted ? "Solunn - Generator" : "Solunn - Creative Meditation & Ambient Soundscape Generator"}
        description={isAudioStarted ? "Generating immersive audio with Solunn." : "Breathe. Touch. Create. A serene space for crafting calming soundscapes and ambient audio."}
      />

      {isAudioStarted ? (
        <Suspense fallback={<LoadingScreen message="Initializing sonic environment..." />}>
          <Experience />
        </Suspense>
      ) : (
        <LandingScreen onStartAudio={handleStartAudio} />
      )}
    </div>
  );
};

const App: React.FC = () => {
  return (
    <AudioProvider>
      <SolunnContent />
    </AudioProvider>
  );
};

export default App;
